module.exports = __webpack_public_path__ + "img/carousel.bf24262e.png";